/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from "zod/v4";

export const goodLuckCoreDTOsRiotAccountDtoSchema = z.object({
  id: z.string().nullish(),
  gameName: z.string().nullish(),
  tagLine: z.string().nullish(),
  region: z.string().nullish(),
  verified: z.optional(z.boolean()),
  avatar: z.string().nullish(),
  profileIconId: z.optional(z.int()),
  isMain: z.optional(z.boolean()),
  rank: z.string().nullish(),
});
